import type { RouteRecordRaw } from 'vue-router'

export const schedulingRoutes: RouteRecordRaw[] = [
  {
    path: '/scheduling/classes',
    name: 'classes-index',
    redirect: '/scheduling/class-sessions',
    meta: { requiresAuth: true, roles: ['owner', 'admin', 'staff'] },
  },
  {
    path: '/scheduling/class-types',
    name: 'class-types',
    component: () => import('./views/ClassTypesView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin', 'staff'] },
  },
  {
    path: '/scheduling/class-sessions',
    name: 'class-sessions',
    component: () => import('./views/ClassSessionsView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin', 'staff'] },
  },
  {
    path: '/scheduling/today',
    name: 'today',
    component: () => import('./views/TodayView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin', 'staff'] },
  },
]
